import {Injectable} from '@angular/core';
import {Observable, retry} from 'rxjs';
import {PermissionPackageDto,} from '@server-models';
import {CoreHttpClientApiBaseService} from "@core/services/http-client-api-base/core-http-client-api-base.service";

@Injectable({
  providedIn: 'root',
})
export class SharedIdentityApiService extends CoreHttpClientApiBaseService {

  getPackages(): Observable<PermissionPackageDto[]> {
    return this.get<PermissionPackageDto[]>(
      `/identity/permissionpackage`,
      false,
    ).pipe(retry({ delay: 7500, count: 2 }));
  }
}
